import ActivityLevels from './ActivityLevels.json';
import {ControlLabel} from 'react-bootstrap';
import PropTypes from 'prop-types';
import React from 'react';
import Slider from 'bodyspec-form-builder/lib/Fields/Slider';

import './Activity.css';


export function ActivityLevel() {
  return (
    <div className='Activity'>
      <ControlLabel>
        See below for examples of various activity levels
      </ControlLabel>
      <ol className='Activity'>
        {
          ActivityLevels.map((level) => (
            <li key={level.name}>
              {level.name}
              <ul>
                <li>{level.descriptions[0]}</li>
                <li>{level.descriptions[1]}</li>
              </ul>
            </li>
          ))
        }
      </ol>
    </div>
  );
}

export function ActivitySlider(props, context) {
  const index = (context.form.get(props.name) || props.min) - 1;
  const level = ActivityLevels[index];
  return (
    <div className='Activity'>
      <Slider {...props} />
      <div className='Activity-Desc'>
        <h3>{level.name}</h3>
        <p>{level.descriptions[0]}</p>
        <p>{level.descriptions[1]}</p>
      </div>
    </div>
  );
}

ActivitySlider.contextTypes = {
  form: PropTypes.object.isRequired,
};

ActivitySlider.propTypes = {
  min: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Intake/Custom/Activity.js